import { Injectable } from '@angular/core';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShiftsIconRenderingHelperService {
  @WilsonState<boolean>(false)
  private isLastShiftRenderedInTimeline!: boolean;
  public readonly isLastShiftRenderedInTimeline$!: Observable<boolean>;

  @WilsonState<boolean>(false)
  private isLastShiftRenderedInUnassignedRegion!: boolean;
  public readonly isLastShiftRenderedInUnassignedRegion$!: Observable<boolean>;

  public markLastShiftAsRenderedForTimeline(): void {
    this.isLastShiftRenderedInTimeline = true;
  }

  public resetStateForTimeline(): void {
    this.isLastShiftRenderedInTimeline = false;
  }

  public markLastShiftAsRenderedForUnassignedRegion(): void {
    this.isLastShiftRenderedInUnassignedRegion = true;
  }

  public resetStateForUnassignedRegion(): void {
    this.isLastShiftRenderedInUnassignedRegion = false;
  }
}
